module.exports = __webpack_public_path__ + "img/add-friend.0d28eab9.png";